@let groupLabel = label();

@if (groupLabel) {
  <p class="label">{{ groupLabel }}</p>
}

<ng-content />
